/**
 * WebSocket 再接続バックオフ（STU-H2対応）
 *
 * 障害復旧時は全クライアントが同時に切断されるため、ジッタのない固定バックオフでは
 * 再接続とその後の再同期 REST（/questions/current・チャット履歴など）が
 * 同時刻に波状集中する（thundering herd）。遅延の後半をランダム化して分散させる。
 */

/** 再接続バックオフの指数上限（2^10秒 > cap 30秒 のためこれ以上は増やさない） */
export const MAX_BACKOFF_EXPONENT = 10;

/**
 * 指数バックオフ + ジッタの遅延（ms）を返す。
 * 基準値（1秒 × 2^attempt、上限30秒）の 50〜100% の範囲でランダム化する（equal jitter）。
 */
export function backoffDelayMs(attempt: number): number {
  const base = Math.min(1000 * Math.pow(2, attempt), 30000);
  return Math.floor(base / 2 + Math.random() * (base / 2));
}

/**
 * keep-alive（ka）途絶の検知しきい値のデフォルト（ms）。
 * AppSync Events は connection_ack の connectionTimeoutMs で
 * アイドルタイムアウトを通知する（デフォルト5分）。それが取得できない場合に使用する。
 */
export const DEFAULT_KA_TIMEOUT_MS = 5 * 60 * 1000;
